import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutTableStopsUnauthenticated extends Layout {
    sourceOrderStops: DataSource;
    tableStops: Table;
}
